var app_pending_makegood_table = $('#app-pending-makegood-table');

if (app_pending_makegood_table.length) {
    var reload_datatable = false;
    var global_view_type = 1;
    var data_table_order= [ 7, "desc" ];
    function initializeMakegoodPendingTable(range = "") {
        app_pending_makegood_table.DataTable({
            "processing": true,
            "serverSide": true,
            ajax: {
               // url: '/makegoods/index?view_type='+ global_view_type,
                url: '/communications_hub/index?view_type='+ global_view_type,
                dataSrc: 'data',
            },
            order: [ 6, "desc" ],
            columns: [
                {data: 'rev_id'},//0
                {data: 'status'},//1
                {data: 'reference_number'},//2
                {data: 'revision_number'},//3
                {data: 'vendor_name'},//4
                {data: 'quantity'},//5
                {data: 'received_at'},//6
                {data: 'campaign_name'},//7
                {data: 'communication_type'},//8
                {data: 'rev_id'},//9
                {data: 'rev_id'},//10
            ],
            destroy: true,
            pageLength: user_entries,
            "columnDefs": [
                {
                    "targets": 0,
                    "orderable": false,
                    "className": "text-left",
                    "visible": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                     // if(rowData.icon == "Sent")
                     //     var html = ' <div class="checkbox checkbox-danger makegoods_check"> <input class="checkbox" class="form-control" type="checkbox"  id="' + rowData.rev_id + '" name="selected_makegoods[]" value="' + rowData.rev_id + '" ><label for="' + rowData.id + '"> </label></div>';
                     //
                     // else
                     //     var html = '';
                     //    $(td).html(html);
                    }
                },
                {
                    "targets": 7,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        console.log('rowData......', rowData);
                        console.log('row......', row);
                        $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                    }
                },
                {
                    "targets": 4,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        console.log('rowData......', rowData);
                        console.log('row......', row);
                        $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                    }
                },
                {
                    "targets": 8,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        if(parseInt(cellData) === 1)
                            html += '<i style="color: #f15925" class="fa fa-handshake-o" title="MakeGood"></i>';
                        else if(parseInt(cellData) === 2)
                            html += '<i style="color: #f15925" class="fa fa-shopping-cart fa-fw" title="Order"></i>';
                        else if(parseInt(cellData) === 3)
                            html += '<i style="color: #f15925" class="fa fa-book" title="Proposal"></i>';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 5,
                    "orderable": false,
                },
                {
                    "targets": 1,
                    "orderable": false,
                    "visible": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        if(rowData.icon == "New")
                            html += '<div style="margin-left: 0%"><b><i class="fa fa-envelope" style="color:#1b6d85; font-size: 100% "></i></b></div>';
                        else if(rowData.icon == "Sent")
                            html += '<div style="margin-left: 0%"><i class="fa fa-paper-plane" style="color:green; font-size: 100% "></i></div>';
                        else
                            html += '<div style="margin-left: 0%"><i class="fa fa-envelope-open-o" style=" font-size: 100% "></i></div>';
                        console.log('html status', html)
                        $(td).html(html);
                    }
                },
                {
                    "targets": 2,
                    "orderable": true,
                    "visible": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        if(rowData.icon == "New")
                            html = "<span style='color: #1b6d85'><b>"+ cellData +"</b></span>";
                        else
                            html = "<span>"+ cellData +"</span>";
                        $(td).html(html);
                    }
                },
                {
                    "targets": 9,
                    "orderable": false,
                    "className": "text-left",
                    "visible": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        if(rowData.icon == "Sent")
                            var html = ' <div class="checkbox checkbox-danger makegoods_check"> <input class="checkbox" class="form-control" type="checkbox"  id="' + rowData.rev_id + '" name="selected_makegoods[]" value="' + rowData.rev_id + '" ><label for="' + rowData.id + '"> </label></div>';
                        else
                            var html = '';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 10,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        html = '<div class="row text-center " style="">' ;
                        html +=    '<div class="btn-group " role="group" >';
                        html += ' <button class="btn btn-primary btn-outline btn-sm display_makegood_lines " data-status = "'+ rowData.icon +'" type="button"  data-id="' + rowData.rev_id + '"><i class="fa fa-eye"></i> Display </button> ';
                        html += ' <button class="btn btn-info btn-outline btn-sm display_makegood_record " type="button"  data-id="' + rowData.rev_id + '"><i class="fa fa-cloud"></i> Record </button> ';

                        html += '</div>' ;
                        // if(rowData.icon == "Sent")
                        //      html += ' <div class="checkbox checkbox-danger makegoods_check"> <input class="checkbox" class="form-control" type="checkbox"  id="' + rowData.rev_id + '" name="selected_makegoods[]" value="' + rowData.rev_id + '" ><label for="' + rowData.id + '"> </label></div>';

                        html +=  '</div>';

                        $(td).html(html);
                    }
                },
            ]
        });
    }
    $('#app-pending-makegood-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries= len;
    });
    $('#app-pending-makegood-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order=[len[0].col, ""+len[0].dir+""];
    } );

    //Search Function
    $('#advertiser-search-order').select2({
        minimumResultsForSearch: 5,
        placeholder: 'Select one....',
    });
    $('#vendor-search-order').select2({
        minimumResultsForSearch: 5,
        placeholder: 'Select one....',
    });

    $('#campaign-search-order').select2({
        minimumResultsForSearch: 5,
        placeholder: 'Select one....',
    });
    $('#market-search-order-index').select2({
        minimumResultsForSearch: 5,
        placeholder: 'Select one....',
    });
    $('#advertiser-search-order').on('change', function(){
        if($('#advertiser-search-order option:selected').val() == '' || $('#advertiser-search-order option:selected').val() == 'undefined') {
            $('#campaign-search-order').html('');
            $('#vendor-search-order').html('');
            $('#market-search-order-index').html('');
        }
        else{
            show_loader();
            $.ajax({
                type: 'GET',
                url: '/invoices/search_campaign/' + $('#advertiser-search-order option:selected').val(),
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var html='';
                    console.log('***************************************');
                    console.log(data);
                    for(var i in data.campaigns)
                        html+='<option value="'+data.campaigns[i].id+'">'+data.campaigns[i].name+'</option>';
                    $('#campaign-search-order').html(html);

                    $('#vendor-search-order').html('');
                    $('#market-search-order-index').html('');
                    hide_loader();

                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });
    $('#campaign-search-order').on('change', function(){
        if($('#campaign-search-order').val().length == 0 ) {
            $('#vendor-search-order').html('');
            $('#market-search-order-index').html('');
        }
        else{
            show_loader();
            var params={
                campaigns: $('#campaign-search-order').val(),
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/orders/all/search_campaign_vendors',
                dataType: "json",
                contentType: "application/json",
                success: function (data) {
                    var html='';
                    console.log('***************************************');
                    console.log(data);
                    for(var i in data.vendors)
                        html+='<option value="'+data.vendors[i].id+'">'+data.vendors[i].name+'</option>';
                    $('#vendor-search-order').html(html);

                    var html='';
                    for(var i in data.markets)
                        html+='<option value="'+data.markets[i].id+'"> '+data.markets[i].type.toUpperCase()+'- '+data.markets[i].name+'</option>';

                    $('#market-search-order-index').html(html);
                    hide_loader();

                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });

    $('#reset-sta-search-order-index').on('click', function () {
        show_loader();
        var html= $('#advertiser-search-order').html();
        $('#advertiser-search-order').html('');
        var advertisers_xd = [];
        advertisers_xd.push({'id': '', 'text': '', 'title': ''});
        $.each(advertisers, function (index, value) {
            advertisers_xd.push({'id': value.id, 'text': value.name, 'title': value.name});
        });

        advertisers_xd.sort(function (a, b) {if (a.text > b.text) {return 1;}if (a.text < b.text) {return -1;}return 0;});
        $('#advertiser-search-order').html('').select2({
            'data': advertisers_xd,
            placeholder: "Select one...",
        });
        $('#campaign-search-order').html('');
        $('#vendor-search-order').html('');
        $('#market-search-order-index').html('');
        hide_loader();
    });

    $('#submit-search-order-all-index').on('click', function () {
        SearchOrder();
    });
    $('#show_all').on('click', function(){
        show_view_data_table(1);
    });
    $('#show_only_new').on('click', function(){
        show_view_data_table(2);
    });
    $('#show_only_viewed').on('click', function(){
        show_view_data_table(3);
    });
    $('#show_only_sent').on('click', function(){
        show_view_data_table(4);
    });

    function SearchOrder() {
        var market= JSON.stringify($('#market-search-order-index').val());
        var advertiser=  $('#advertiser-search-order').val();
        var camp=  JSON.stringify($('#campaign-search-order').val());
        var vend= JSON.stringify( $('#vendor-search-order').val());

        if(( advertiser == '' || advertiser == null) && market.length ==0 && camp.length == 0 && vend.length == 0)
            global_notification('warning', 'Please select at least one search parameter...');
        else {
            show_loader();
            $('#panel_click_ven_search').addClass('panel-collapsed');
            $('#panel_body_search_vendor').css('display', 'none');

            var url = encodeURI('/makegoods/index?view_type='+ global_view_type +'&advertiser='+advertiser+'&campaigns='+camp+'&markets='+market+'&vendors='+vend+'');

            $('#app-pending-makegood-table').DataTable().ajax.url(url).load();
            hide_loader();
        }
    }

    function show_view_data_table(type) {
        if (type == 1) {
            $('.makegood_filters').html('&nbsp;Show All')
            $('.makegood_filters').attr('data-value', 1)
        }
        if (type == 2) {
            $('.makegood_filters').html('&nbsp;New')
            $('.makegood_filters').attr('data-value', 2)
        }
        if (type == 3) {
            $('.makegood_filters').html('&nbsp;Viewed')
            $('.makegood_filters').attr('data-value', 3)
        }
        if (type == 4) {
            $('.makegood_filters').html('&nbsp;Sent')
            $('.makegood_filters').attr('data-value', 4)
        }
        var market= JSON.stringify($('#market-search-order-index').val());
        var advertiser=  $('#advertiser-search-order').val();
        var camp=  JSON.stringify($('#campaign-search-order').val());
        var vend= JSON.stringify( $('#vendor-search-order').val());

        global_view_type = type;
        if(( advertiser == '' || advertiser == null) && market.length ==0 && camp.length == 0 && vend.length == 0)
            var url = encodeURI('/makegoods/index?view_type='+ global_view_type);
        else
            var url = encodeURI('/makegoods/index?view_type='+ global_view_type +'&advertiser='+advertiser+'&campaigns='+camp+'&markets='+market+'&vendors='+vend+'');
        console.log('url', url);

        $('#app-pending-makegood-table').DataTable().ajax.url(url).load();

    }

    //Select/Descelect all
    $('#select_all_makegoods').on('click', function (e) {
        $('#app-pending-makegood-table input:checkbox').each(function () {
            $(this).prop('checked', true);
        });
    });
    $('#deselect_all_makegoods').on('click', function (e) {
        $('#app-pending-makegood-table input:checkbox').prop('checked', false);
    });

    $('#move_completed').on('click', function(){
        var url= $(this).attr('data-url');
        var selectedItems = [];
        $('.makegoods_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        if (selectedItems.length == 0) {
            swal({
                    title: "Warning!",
                    text: "Please select at least one Order.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    //cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                    }
                });
        }
        else{
            show_loader();
            var params = {
                orders: selectedItems,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    hide_loader();
                    global_notification('success', 'Order moved to Completed.');
                    location.reload();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
    });

    var extended_from_weeks = {
        'week':    {
            headerName: '',
            field: 'week_',
            width: 100,
            cellStyle: {'text-align': "left"},
            editable: false,
           // cellRenderer: IntegerFormatRenderer,
            tooltip: function (params) {
                if (typeof params.data !== 'undefined') {
                    var index = params.colDef.field;
                    index = index.toString().split('_')[1];
                    if (typeof params.data['increase_' + index] !== 'undefined')
                        return 'Spots Increase By: ' + params.data['increase_' + index];
                    if (typeof params.data['decrease_' + index] !== 'undefined')
                        return 'Spots Decrease By: ' + params.data['decrease_' + index];
                }
            },
            cellClassRules :  {
                'ag-cell-color-increase-makegood': function(params) {
                    var index = params.colDef.field;
                    index = index.toString().split('_')[1];
                    if (typeof params.data !== 'undefined' && typeof params.data['increase_' + index] !== 'undefined')
                        return true;
                },
                'ag-cell-color-decrease-makegood': function(params) {
                    var index = params.colDef.field;
                    index = index.toString().split('_')[1];
                    if (typeof params.data !== 'undefined' && typeof params.data['decrease_' + index] !== 'undefined')
                        return true;
                }
            },
        },
        'tired_rate':    {
            headerName: '',
            field: 'w_',
            width: 100,
            cellStyle: {'text-align': "left"},
            editable: true,
            cellRenderer: TiredRateMakeGoodFormatRenderer,
        },
    }

    function checkboxSelection(params) {
        if(params.node.level === 0 && typeof params.node.childrenAfterFilter[0] !== 'undefined')
            if(params.node.childrenAfterFilter[0].data.status == 'New' || params.node.childrenAfterFilter[0].data.status == 'Viewed')
                return params.node.group === true;
    }

    function checkbox(params) {
        if(params.node.level === 0 && typeof params.node.childrenAfterFilter[0] !== 'undefined') {
            console.log('checkbox params', params)
            console.log('checkbox params dfg', params.node.childrenAfterFilter[0] )
            if (params.node.childrenAfterFilter[0].data.status == 'New' || params.node.childrenAfterFilter[0].data.status == 'Viewed')
                return params.node.group === true;
        }

    }

    //Make Good Grid
    var makegoodLinesColumnDef = [];
    var gridMakegoodLines = {
        columnDefs: makegoodLinesColumnDef,
        autoGroupColumnDef: {
            headerName: 'MakeGoods',//custom header name for group
            pinned: 'left',//force pinned left. Does not work in columnDef
            suppressMovable: true,
            suppressFilter: false,
            cellRenderer: 'agGroupCellRenderer',
              cellRendererParams: {
                suppressCount: true,//remove number in Group Column
                suppressMovable: true,
                suppressFilter: false,
                checkbox: checkbox,
            },

        },
        defaultColDef: {
            width: 150,
            suppressToolPanel: true
        },
        enableColResize: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        suppressTouch: true,
        headerHeight: 25,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            // groupExpanded: '<i class="fa fa-chevron-down"></i>',
            // groupContracted: '<i class="fa fa-chevron-right"></i>',
           // groupExpanded: '<i class="fa fa-angle-down"></i>',
         //   groupContracted: '<i class="fa fa-angle-right"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onFilterChanged: function (e) {
            if (this.api.isAnyFilterPresent())
                $('#reset_filters_makegood_section').show();
            else
                $('#reset_filters_makegood_section').hide();
        },
    };

    //Order Lines Grid
    var orderLinesColumnDef = [];
    var gridOrderLines = {
        columnDefs: orderLinesColumnDef,
        defaultColDef: {
            suppressToolPanel: true
        },
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        enableColResize: true,
        //suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onFilterChanged: function (e) {
            if (this.api.isAnyFilterPresent())
                $('#reset_filters_buyline_section').show();
            else
                $('#reset_filters_buyline_section').hide();
        },
    };

    //Record Order Lines Grid
    var orderLinesRecordColumnDef = [];
    var gridRecordOrderLines = {
        columnDefs: orderLinesRecordColumnDef,
        autoGroupColumnDef: {
            headerName: 'MakeGoods',//custom header name for group
            pinned: 'left',//force pinned left. Does not work in columnDef
            suppressMovable: true,
            suppressFilter: false,
            groupDefaultExpanded: -1,
            cellRendererParams: {
                suppressCount: true,//remove number in Group Column
                suppressMovable: true,
                suppressFilter: false,
            }
        },
        defaultColDef: {
            width: 150,
            suppressToolPanel: true
        },
        enableColResize: true,
        suppressTouch: true,
        headerHeight: 25,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: -1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
          //  groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
          //  groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        onFilterChanged: function (e) {
            if (this.api.isAnyFilterPresent())
                $('#reset_filters_makegood_record').show();
            else
                $('#reset_filters_makegood_record').hide();
        },
        onGridReady: function (e) {
            this.api.collapseAll();
            this.api.expandAll();
        },
    };
    var makegood_mismatch = [];

    //Display Function
    $('#app-pending-makegood-table').on('click', '.display_makegood_lines', function () {
        reload_datatable = false;
        if($(this).attr('data-status') == 'New')
            reload_datatable = true;
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/makegoods/display/order_revision/' + $(this).attr('data-id'),
            dataType: 'json',
            encode: true,
            success: function (data) {
                //MakeGood Grid Column Defs
                makegoodLinesColumnDef = [
                    {
                        headerName: "MakeGood #",
                        field: 'makegood_reference_id',
                        width: 80,
                        cellStyle: {'text-align': "right"},
                        rowGroupIndex: 0,
                        hide: true,
                        suppressMovable: true,
                        pinned: 'left',
                        //headerClass: 'fixedHeaderCellClass'
                    },
                    {
                        headerName: "",
                        field: 'status',
                        width: 35,
                        cellStyle: {'text-align': "center"},
                        pinned: 'left',
                        suppressMovable: true,
                        cellRenderer: function(params) {
                            var html = '';
                            if(params.node.level == 0) {
                                $.each(params.node.childrenAfterFilter, function (index, value) {
                                    if(index == 0) {
                                        if (value.data.status == 'New')
                                            html += "  <span style='margin-bottom: 20%'> <i style='color: #1b6d85; font-weight: bolde…nt-weight: bolder; text-align: center; ' class='fa fa-envelope'></i> </span> ";
                                        if (value.data.status == 'Approved')
                                            html += "  <span><i style='color: green; font-weight: bolde…nt-weight: bolder' class='fa fa-check-square-o'></i> </span> ";
                                        if (value.data.status == 'Declined' || value.data.status == 'Reject')
                                            html += "  <span><i style='color: darkred; font-weight: bolde…nt-weight: bolder' class='fa fa-times'></i> </span> ";
                                        if (value.data.status == 'Viewed')
                                            html += "  <span><i style='font-weight: bolde…nt-weight: bolder' class='fa fa-envelope-open-o'></i>  </span> ";
                                    }
                                });

                            }
                            var tempDiv = document.createElement('div');
                            tempDiv.innerHTML = html;
                            this.eGui = tempDiv.firstElementChild;
                            return this.eGui;
                        },
                    },
                    {
                        headerName: "Rev id",
                        field: 'rev_id',
                        width: 60,
                        cellStyle: {'text-align': "right"},
                        hide :true
                    },
                    {
                        headerName: "Line #",
                        field: 'line_number',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                        editable:true,
                        tooltip: function (params) {
                            if (typeof params.data !== 'undefined' && isNaN(parseInt(params.data.line_number)))
                                return 'This is a new Buy Line offered by the seller.';
                        },
                        cellClassRules :  {
                            'ag-cell-color-newbuyline-makegood': function(params) {
                                if (typeof params.data !== 'undefined' && isNaN(parseInt(params.data.line_number)))
                                    return true;
                            },

                        },
                    }, {
                        headerName: "Time",
                        field: 'time',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                        editable:true
                    },
                    {
                        headerName: "Days",
                        field: 'days',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                        editable:true
                    },
                    {
                        headerName: "Network",
                        field: 'network',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                        editable:true
                    },
                    {
                        headerName: "Rating",
                        field: 'rating',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                        editable:true
                    },
                    {
                        headerName: "Program",
                        field: 'program',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                        editable:true
                    },
                    {
                        headerName: "Gross Rate",
                        field: 'gross_cpa',
                        width: 90,
                        cellStyle: {'text-align': "right"},
                        cellRenderer: function(params) {
                            if(params.node.level == 1) {
                                this.eGui = document.createElement('div');
                                $(this.eGui).css('text-align', 'right');
                                if (params.node.data.tiered_rate == 1)
                                    this.eGui.innerHTML = 'TR';
                                else {
                                    if (isNaN(parseFloat(params.value)))
                                        this.eGui.innerHTML = '$0.00';
                                    else
                                        this.eGui.innerHTML = parseFloat(params.value).toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            //minimumFractionDigits: 2
                                        });
                                }

                                return this.eGui;
                            }
                        },
                        cellClassRules :  {
                            'ag-cell-color-background': function(params) {
                                if(params.node.level == 1) {
                                    if (typeof params.node.data.tiered_rate !== 'undefined' && params.node.data.tiered_rate === 1)
                                        return true;
                                    else
                                        return false;
                                }
                            }
                        },
                    },
                    {
                        headerName: "Net Rate",
                        field: 'net_cpa',
                        width: 90,
                        cellStyle: {'text-align': "right"},
                        cellRenderer: function(params) {
                            if(params.node.level == 1) {
                                this.eGui = document.createElement('div');
                                $(this.eGui).css('text-align', 'right');
                                if (params.node.data.tiered_rate == 1)
                                    this.eGui.innerHTML = 'TR';
                                else {
                                    if (isNaN(parseFloat(params.value)))
                                        this.eGui.innerHTML = '$0.00';
                                    else
                                        this.eGui.innerHTML = parseFloat(params.value).toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            //minimumFractionDigits: 2
                                        });
                                }

                                return this.eGui;
                            }
                        },
                        cellClassRules :  {
                            'ag-cell-color-background': function(params) {
                                if(params.node.level == 1) {
                                    if (typeof params.node.data.tiered_rate !== 'undefined' && params.node.data.tiered_rate === 1)
                                        return true;
                                    else
                                        return false;
                                }
                            }
                        },
                    },
                    {
                        headerName: "Len",
                        field: 'len',
                        width: 80,
                        cellStyle: {'text-align': "right"},
                        editable:false
                    },
                    {
                        headerName: "Comment",
                        field: 'comment',
                        width: 300,
                        cellStyle: {'text-align': "right"},
                        pinned: 'right',
                        editable:false,
                        tooltip: function (params) {
                            if (typeof params.data !== 'undefined') {
                                var index = params.colDef.field;
                                index = index.toString().split('_')[1];
                                if (typeof params.data['increase_' + index] !== 'undefined')
                                    return 'Spots Increase By: ' + params.data['increase_' + index];
                                if (typeof params.data['decrease_' + index] !== 'undefined')
                                    return 'Spots Decrease By: ' + params.data['decrease_' + index];
                            }
                        },
                        cellClassRules :  {
                            'ag-cell-color-newbuyline-makegood': function(params) {
                                if (typeof params.data !== 'undefined' && isNaN(parseInt(params.data.line_number)))
                                    return true;
                            },

                        },
                    },

                ];

                //Order Buy Lines Column Defs
                orderLinesColumnDef = [
                    {
                        headerName: "Rev id",
                        field: 'rev_id',
                        width: 60,
                        cellStyle: {'text-align': "right"},
                        hide :true
                    },
                    {
                        headerName: "Line #",
                        field: 'line_number',
                        width: 60,
                        cellStyle: {'text-align': "right"},
                        editable:true,
                        pinned: 'left',
                    }, {
                        headerName: "Time",
                        field: 'time',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                        editable:true
                    },
                    {
                        headerName: "Days",
                        field: 'days',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                    },
                    {
                        headerName: "Network",
                        field: 'network',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                    },
                    {
                        headerName: "Program",
                        field: 'program',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                    },
                    {
                        headerName: "Rating",
                        field: 'rating',
                        width: 100,
                        cellStyle: {'text-align': "right"},
                        editable:true
                    },
                    {
                        headerName: "Gross Rate",
                        field: 'gross_cpa',
                        width: 90,
                        cellStyle: {'text-align': "right"},
                        cellRenderer: function(params) {
                            this.eGui = document.createElement('div');
                            $(this.eGui).css('text-align', 'right');
                            if(params.node.data.tiered_rate == 1)
                                this.eGui.innerHTML = 'TR';
                            else{
                                if (isNaN(parseFloat(params.value)))
                                    this.eGui.innerHTML = '$0.00';
                                else
                                    this.eGui.innerHTML =  parseFloat(params.value).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                        //minimumFractionDigits: 2
                                    });
                            }

                            return this.eGui;
                        },
                        cellClassRules :  {
                            'ag-cell-color-background': function(params) {
                                if(typeof params.node.data.tiered_rate !== 'undefined' && params.node.data.tiered_rate === 1)
                                    return true;
                                else
                                    return false;
                            }
                        },
                    },
                    {
                        headerName: "Net Rate",
                        field: 'net_cpa',
                        width: 90,
                        cellStyle: {'text-align': "right"},
                        cellRenderer: function(params) {
                            this.eGui = document.createElement('div');
                            $(this.eGui).css('text-align', 'right');
                            if(params.node.data.tiered_rate == 1)
                                this.eGui.innerHTML = 'TR';
                            else{
                                if (isNaN(parseFloat(params.value)))
                                    this.eGui.innerHTML = '$0.00';
                                else
                                    this.eGui.innerHTML =  parseFloat(params.value).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                        //minimumFractionDigits: 2
                                    });
                            }

                            return this.eGui;
                        },
                        cellClassRules :  {
                            'ag-cell-color-background': function(params) {
                                if(typeof params.node.data.tiered_rate !== 'undefined' && params.node.data.tiered_rate === 1)
                                    return true;
                                else
                                    return false;
                            }
                        },
                    }, {
                        headerName: "Len",
                        field: 'len',
                        width: 80,
                        cellStyle: {'text-align': "right"},
                        editable:true
                    },
                ];

                var camp_fd_ordered = data.FD;
                for(var i in camp_fd_ordered){
                    var tiered_weeks = {
                        headerName: 'Week: '+ moment(camp_fd_ordered[i].start).format('MM/DD'),
                        headerTooltip: "Week: "+ moment(camp_fd_ordered[i].start).format('MM/DD'),
                        groupId: moment(camp_fd_ordered[i].start).format('MM/DD'),
                        children: [],
                        headerClass: 'group-header'
                    };
                    var row =  $.extend({}, extended_from_weeks.tired_rate);
                    row.field = 'w_'+ camp_fd_ordered[i].id + '_tired';
                    row.headerName = 'Rate';
                    tiered_weeks.children.push(row);

                    var row =  $.extend({}, extended_from_weeks.week);
                    row.field = 'week_'+ camp_fd_ordered[i].id ;
                    row.headerName = 'Ads';
                    tiered_weeks.children.push(row);

                    makegoodLinesColumnDef.push(tiered_weeks);
                    orderLinesColumnDef.push(tiered_weeks);
                }

                var rowDataMakeGood = data.makegood_lines;
                var rowOrderLines =  data.order_lines;

                $('#makegoodGridDiv').html('');
                gridMakegoodLines.columnDefs = makegoodLinesColumnDef;
                gridMakegoodLines.rowData = rowDataMakeGood;
                var gridMakegoodLinesDiv = document.querySelector('#makegoodGridDiv');
                var g1 = new agGrid.Grid(gridMakegoodLinesDiv, gridMakegoodLines);

                var html_1= '';
                for(var ind in makegoodLinesColumnDef){
                    if(makegoodLinesColumnDef[ind].headerName !== 'Rev id' &&  makegoodLinesColumnDef[ind].headerName !== 'MakeGood #') {
                        if (typeof makegoodLinesColumnDef[ind].children === 'undefined') {
                            html_1 += '<li style="font-size: 12px; margin-bottom: -1px; margin-top: -1px;">' +
                                '<a class="dropdown-item " data-hidden="' + makegoodLinesColumnDef[ind].field + '" > ' + makegoodLinesColumnDef[ind].headerName.replace('<br>', '') + '</a></li>';
                        } else {
                            for (var ind2 in makegoodLinesColumnDef[ind].children) {
                                html_1 += '<li style="font-size: 12px; margin-bottom: -1px; margin-top: -1px;">' +
                                    '<a class="dropdown-item " data-hidden="' + makegoodLinesColumnDef[ind].children[ind2].field + '" > ' + makegoodLinesColumnDef[ind].headerName + ' ' + makegoodLinesColumnDef[ind].children[ind2].headerName + '</a></li>';
                            }
                        }
                    }
                }
                $("#hide_columns_display_makegood_sections").html(html_1);

                $('#buyGridDiv').html('');
                gridOrderLines.columnDefs = orderLinesColumnDef;
                gridOrderLines.rowData = rowOrderLines;
                var gridMakegoodLinesDiv = document.querySelector('#buyGridDiv');
                var g1 = new agGrid.Grid(gridMakegoodLinesDiv, gridOrderLines);

                var html_1= '';
                for(var ind in orderLinesColumnDef){
                    if(orderLinesColumnDef[ind].headerName !== 'Rev id') {
                        if (typeof orderLinesColumnDef[ind].children === 'undefined') {
                            html_1 += '<li style="font-size: 12px; margin-bottom: -1px; margin-top: -1px;">' +
                                '<a class="dropdown-item " data-hidden="' + orderLinesColumnDef[ind].field + '" > ' + orderLinesColumnDef[ind].headerName.replace('<br>', '') + '</a></li>';
                        } else {
                            for (var ind2 in orderLinesColumnDef[ind].children) {
                                html_1 += '<li style="font-size: 12px; margin-bottom: -1px; margin-top: -1px;">' +
                                    '<a class="dropdown-item " data-hidden="' + orderLinesColumnDef[ind].children[ind2].field + '" > ' + orderLinesColumnDef[ind].headerName + ' ' + orderLinesColumnDef[ind].children[ind2].headerName + '</a></li>';
                            }
                        }
                    }
                }
                $("#hide_columns_display_buyline_sections").html(html_1);

                $('#order_ref_span').html(data.campaigns[0].reference_number);
                $('#order_rev_n_span').html(data.campaigns[0].revision_number);
                $('#station_order_div').html(data.campaigns[0].vendor_name);

                var market = '';
                if(data.campaigns[0].market_type == '')
                    market = 'Custom - ' + data.campaigns[0].market_name;
                else if(data.campaigns[0].market_type == 'National')
                    market = 'National - ' + data.campaigns[0].market_name;
                else
                    market =  data.campaigns[0].market_type.toUpperCase() + ' - ' + data.campaigns[0].market_name;
                $('#market_order_div').html(market);

                $('#displayMakeGoodModal').modal('show');

                makegood_mismatch = data.makegood_mismatch;
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });

    $('#select_makegood_grid').on('click', function () {

        gridMakegoodLines.api.forEachNodeAfterFilter(function(node) {
            console.log('forEachNodeAfterFilter', node);
            if(node.level === 0) {
                if(typeof node.childrenAfterFilter !== 'undefined' && typeof node.childrenAfterFilter[0] !== 'undefined') {
                    if (node.childrenAfterFilter[0].data.status == 'New' || node.childrenAfterFilter[0].data.status == 'Viewed')
                        node.setSelected(true);
                }
            }
        });
    });
    $('#deselect_makegood_grid').on('click', function () {
        gridMakegoodLines.api.deselectAll();
    });

    $(document).on('click', '.hide_columns_display_makegood_sections a' , function (e){
        if ($(this).hasClass('hidden-column')) {
            gridMakegoodLines.columnApi.setColumnVisible($(this).attr('data-hidden'), true);
            $(this).removeClass('hidden-column');
        } else {
            gridMakegoodLines.columnApi.setColumnVisible($(this).attr('data-hidden'), false);
            $(this).addClass('hidden-column');
        }
        e.stopPropagation();
    });
    $(document).on('click', '.hide_columns_display_buyline_sections a' , function (e){
        if ($(this).hasClass('hidden-column')) {
            gridOrderLines.columnApi.setColumnVisible($(this).attr('data-hidden'), true);
            $(this).removeClass('hidden-column');
        } else {
            gridOrderLines.columnApi.setColumnVisible($(this).attr('data-hidden'), false);
            $(this).addClass('hidden-column');
        }
        e.stopPropagation();
    });

    $('#reset_filters_makegood_section').on('click', function () {
        $.each(gridMakegoodLines.api.getFilterModel(), function (index, value) {
            gridMakegoodLines.api.destroyFilter(index);
        });
    });
    $('#reset_filters_buyline_section').on('click', function () {
        $.each(gridOrderLines.api.getFilterModel(), function (index, value) {
            gridOrderLines.api.destroyFilter(index);
        });
    });
    $('#approve_makegood_grid').on('click', function() {
        $('#approveMakeGoodWarningDivMismatch').html('');
        if(gridMakegoodLines.api.getSelectedNodes().length > 0) {
          $('#approveMakeGoodWarningDiv').html("You are about to accept the selected <b>("+ gridMakegoodLines.api.getSelectedNodes().length +")</b> MakeGoods.\n");
          var html_new = '<br><span style="color: #e07a51; margin-bottom: 1%"> <b>The following MakeGood(s) have offerings that deviate from the original Order.</b> </span> <br>';
          var added = [];
          var html_body = '';
          console.log('value nodes_to_update makegood_mismatch ', makegood_mismatch)
            var cont = 0;
            for(var i in gridMakegoodLines.api.getSelectedNodes()) {
                if(gridMakegoodLines.api.getSelectedNodes()[i].level == 0) {
                    $.each(gridMakegoodLines.api.getSelectedNodes()[i].childrenAfterFilter, function (index, value) {
                        console.log('value nodes_to_update', value)
                        if(typeof makegood_mismatch[value.data.makegood_id] !== 'undefined' && added.indexOf(value.data.makegood_id) === -1){
                            added.push(value.data.makegood_id);
                            html_body += '<b><span style=" margin-left: 1%">'+ value.data.makegood_reference_id +'</b></span><br>'
                            if(makegood_mismatch[value.data.makegood_id]['mg_spot'] > makegood_mismatch[value.data.makegood_id]['order_spot']){
                                var pt =  parseInt (makegood_mismatch[value.data.makegood_id]['mg_spot'] - makegood_mismatch[value.data.makegood_id]['order_spot']);
                                var tx = (pt > 1) ? 'spots' : 'spot';
                                html_body += '<span style="margin-left: 1%">MakeGood is <b>'+ pt+'</b>  '+ tx +' more than the Ordered Spots.</span><br>';
                                cont++;
                            }
                            if(makegood_mismatch[value.data.makegood_id]['mg_spot'] < makegood_mismatch[value.data.makegood_id]['order_spot']){
                                var pt = parseInt (makegood_mismatch[value.data.makegood_id]['order_spot'] - makegood_mismatch[value.data.makegood_id]['mg_spot']);
                                var tx = (pt > 1) ? 'spots' : 'spot';
                                html_body += '<span style="margin-left: 1%">MakeGood is <b>'+ pt+'</b>  '+ tx +' less than the Ordered Spots.</span><br>';
                                cont++;
                            }
                            if(makegood_mismatch[value.data.makegood_id]['mg_gross'] > makegood_mismatch[value.data.makegood_id]['order_gross']){
                                var pt = parseFloat(makegood_mismatch[value.data.makegood_id]['mg_gross'] - makegood_mismatch[value.data.makegood_id]['order_gross']).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                });
                                html_body += '<span style="margin-left: 1%">MakeGood is <b> '+ pt+'</b>  more than the Ordered Gross.</span><br>';
                                cont++;
                            }
                            if(makegood_mismatch[value.data.makegood_id]['mg_gross'] < makegood_mismatch[value.data.makegood_id]['order_gross']){
                                var pt = parseFloat(makegood_mismatch[value.data.makegood_id]['order_gross'] - makegood_mismatch[value.data.makegood_id]['mg_gross']).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                        minimumFractionDigits: 2
                                    });
                                html_body += '<span style="margin-left: 1%">MakeGood is <b>'+ pt +'</b>  less than the Ordered Gross.</span><br>';
                                cont++;
                            }
                        }
                    });
                }
            }
            if(cont > 0)
                $('#approveMakeGoodWarningDivMismatch').html(html_new + html_body);

            $('#approveMakeGoodWarningModal').modal('show');
        }
        else
            $('#selectMakeGoodWarningModal').modal('show');

    });
    $('#approve_confirm').on('click', function () {
       show_overlay_loader($('#approveMakeGoodWarningModal .modal-content'));
        var params ={
            makegoods: [],
            update_worksheet: ($("input:checkbox[name=update_worksheet]").prop('checked') === true) ? 1 : 0,
        };
        var nodes_to_update = [];
        for(var i in gridMakegoodLines.api.getSelectedNodes()) {
            console.log('gridMakegoodLines.api.getSelectedNodes()', gridMakegoodLines.api.getSelectedNodes()[i]);
            if(gridMakegoodLines.api.getSelectedNodes()[i].level == 0){
                $.each(gridMakegoodLines.api.getSelectedNodes()[i].childrenAfterFilter, function (index, value) {
                    console.log('value nodes_to_update', value)
                    params.makegoods.push(value.data.makegood_id);
                    value.data.status = 'Approved';
                    nodes_to_update.push(gridMakegoodLines.api.getSelectedNodes()[i]);
                });
            }
        }
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/makegoods/orders/approve',
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                reload_datatable = true;
                gridMakegoodLines.api.refreshView();
                gridMakegoodLines.api.deselectAll();
                // for (var i in response)
                //     saveFile("testing approve makeGood.xml", "data:attachment/xml", response[i]);
                for(var i in response['makegoods'])
                    if(response['makegoods'][i] === 'Failed')
                        global_notification('error', "MakeGood with Reference Id " + i + " failed to send to Wide Orbit. Please contact support.");

                $('#approveMakeGoodWarningModal').modal('hide');
                hide_overlay_loader($('#approveMakeGoodWarningModal .modal-content'));
            },
            error: function (xhr) {
                hide_overlay_loader($('#approveMakeGoodWarningModal .modal-content'));
                $("#errorMakeGoodWarningDiv").html('A error has happened: " ' +  xhr.responseText + ' "<br> </br> MakeGoods not Accepted!')
                $('#approveMakeGoodWarningModal').modal('hide');
                $('#errorMakeGoodWarningModal').modal('show');
            }
        });
    });
    $('#decline_makegood_grid').on('click', function() {
        if(gridMakegoodLines.api.getSelectedNodes().length > 0) {
            $('#declineMakeGoodWarningDiv').html("You are about to decline the selected <b>("+ gridMakegoodLines.api.getSelectedNodes().length +")</b> MakeGoods.\n");
            $('#declineMakeGoodWarningModal').modal('show');

        }
        else
            $('#selectMakeGoodWarningModal').modal('show');

    });
    $('#decline_confirm').on('click', function () {
        show_overlay_loader($('#declineMakeGoodWarningModal .modal-content'));
        var params ={
            makegoods: [],
        };
        var nodes_to_update = [];
        for(var i in gridMakegoodLines.api.getSelectedNodes()) {
            console.log('gridMakegoodLines.api.getSelectedNodes()', gridMakegoodLines.api.getSelectedNodes()[i]);
            if(gridMakegoodLines.api.getSelectedNodes()[i].level == 0){
                $.each(gridMakegoodLines.api.getSelectedNodes()[i].childrenAfterFilter, function (index, value) {
                    params.makegoods.push(value.data.makegood_id);
                    value.data.status = 'Declined';
                    nodes_to_update.push(gridMakegoodLines.api.getSelectedNodes()[i]);
                });
            }
        }
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/makegoods/orders/decline',
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                reload_datatable = true;
                gridMakegoodLines.api.refreshView();
                gridMakegoodLines.api.deselectAll();
                // for(var i in response)
                //     saveFile( "testing approve makeGood.xml", "data:attachment/xml", response[i]);
                // global_notification('success', "MakeGood(s) Declined <br> For now we are only exporting the XML file, not sent it to Wide Orbit.")
                for(var i in response['makegoods'])
                    if(response['makegoods'][i] === 'Failed')
                        global_notification('error', "MakeGood with Reference Id " + i + " failed to send to Wide Orbit. Please contact support.");

                $('#declineMakeGoodWarningModal').modal('hide');
                hide_overlay_loader($('#declineMakeGoodWarningModal .modal-content'));

            },
            error: function (xhr) {
                hide_overlay_loader($('#declineMakeGoodWarningModal .modal-content'));
                $("#errorMakeGoodWarningDiv").html('A error has happened: " ' +  xhr.responseText + ' "<br> </br> MakeGoods not Declined!')
                $('#declineMakeGoodWarningModal').modal('hide');
                $('#errorMakeGoodWarningModal').modal('show');
            }
        });
    });

    // Record Function
    $('#app-pending-makegood-table').on('click', '.display_makegood_record', function () {
        show_loader();
        displayRecord( $(this).attr('data-id'));
    });
     function displayRecord(rev_id){
         $.ajax({
             type: 'GET',
             url: '/makegoods/record/order_revision/' + rev_id,
             dataType: 'json',
             encode: true,
             success: function (data) {
                 orderLinesRecordColumnDef = [
                     {
                         headerName: "MakeGood #",
                         field: 'makegood_reference_id',
                         width: 130,
                         cellStyle: {'text-align': "right",'font-weight': "bold"},
                         rowGroupIndex: 0,
                         hide: true,
                         suppressMovable: true,
                     },
                     {
                         headerName: "Line Number",
                         field: 'line_number',
                         width: 100,
                         cellStyle: {'text-align': "right"},
                         rowGroupIndex: 1,
                         hide: true,
                         suppressMovable: true,
                     },
                     {
                         headerName: "",
                         field: 'name',
                         width: 150,
                         cellStyle: {'text-align': "left"},
                         pinned: 'left',
                         hide: false,
                         suppressMovable: true,
                         tooltip: function (params) {
                             if (typeof params.data !== 'undefined' && params.data.name == 'Offered by the seller')
                                 return 'This is a new Buy Line offered by the seller.';
                         },
                         cellClassRules :  {
                             'ag-cell-color-newbuyline-makegood': function(params) {
                                 if (typeof params.data !== 'undefined' && params.data.name == 'Offered by the seller')
                                     return true;
                             },

                         },
                     },
                     {
                         headerName: "Status",
                         field: 'status',
                         width: 80,
                         cellStyle: {'text-align': "left"},
                         pinned: 'left',
                         cellRenderer: function(params) {
                             var html = '';
                             if(params.node.level == 0) {
                                 console.log('params level cero status', params);
                                 $.each(params.node.childrenAfterFilter, function (indexx, valuex) {
                                     $.each(valuex.childrenAfterFilter, function (index, value) {
                                       //  if (index == 0) {
                                             console.log('params level cero status value', value);
                                             if (value.data.status == 'New')
                                                 html += "  <span style='margin-bottom: 20%'> <i style='color: #1b6d85; font-weight: bolde…nt-weight: bolder; text-align: center; ' class='fa fa-envelope'></i> </span> ";
                                             if (value.data.status == 'Approved')
                                                 html += "  <span><i style='color: green; font-weight: bolde…nt-weight: bolder' class='fa fa-check-square-o'></i> </span> ";
                                             if (value.data.status == 'Declined' || value.data.status == 'Reject')
                                                 html += "  <span><i style='color: darkred; font-weight: bolde…nt-weight: bolder' class='fa fa-times'></i> </span> ";
                                             if (value.data.status == 'Viewed')
                                                 html += "  <span><i style='font-weight: bolde…nt-weight: bolder' class='fa fa-envelope-open-o'></i>  </span> ";
                                        // }
                                     });
                                 });
                             }
                             var tempDiv = document.createElement('div');
                             tempDiv.innerHTML = html;
                             this.eGui = tempDiv.firstElementChild;
                             return this.eGui;
                         },

                     },
                     {
                         headerName: "Received at:",
                         field: 'received_at',
                         width: 150,
                         cellStyle: {'text-align': "right"},
                     },
                     {
                         headerName: "Approved/Declined By:",
                         field: 'user',
                         width: 150,
                         cellStyle: {'text-align': "right"},
                     },
                     {
                         headerName: "Approved/Declined at:",
                         field: 'updated_at',
                         width: 150,
                         cellStyle: {'text-align': "right"},
                     },
                     {
                         headerName: "Description",
                         field: 'comment',
                         width: 150,
                         cellStyle: {'text-align': "right"},
                     },
                     {
                         headerName: "Time",
                         field: 'time',
                         width: 100,
                         cellStyle: {'text-align': "right"},
                         editable:true
                     },
                     {
                         headerName: "Days",
                         field: 'days',
                         width: 100,
                         cellStyle: {'text-align': "right"},
                         editable:true
                     },
                     {
                         headerName: "Network",
                         field: 'network',
                         width: 100,
                         cellStyle: {'text-align': "right"},
                         editable:true
                     },
                     {
                         headerName: "Program",
                         field: 'program',
                         width: 100,
                         cellStyle: {'text-align': "right"},
                         editable:true
                     },
                     {
                         headerName: "Rating",
                         field: 'rating',
                         width: 100,
                         cellStyle: {'text-align': "right"},
                         editable:true
                     },
                     {
                         headerName: "Gross Rate",
                         field: 'gross_cpa',
                         width: 90,
                         cellStyle: {'text-align': "right"},
                         cellRenderer: function(params) {
                             this.eGui = document.createElement('div');
                             $(this.eGui).css('text-align', 'right');
                             this.eGui.innerHTML = '';
                             if( typeof params.node.data !== 'undefined') {
                                 if (params.node.data.tiered_rate == 1)
                                     this.eGui.innerHTML = 'TR';
                                 else {
                                     if (isNaN(parseFloat(params.value)))
                                         this.eGui.innerHTML = '$0.00';
                                     else
                                         this.eGui.innerHTML = parseFloat(params.value).toLocaleString("en-US", {
                                             style: "currency",
                                             currency: "USD",
                                             //minimumFractionDigits: 2
                                         });
                                 }
                             }

                             return this.eGui;
                         },
                         cellClassRules :  {
                             'ag-cell-color-background': function(params) {
                                 if( typeof params.node.data !== 'undefined' && typeof params.node.data.tiered_rate !== 'undefined' && params.node.data.tiered_rate === 1)
                                     return true;
                                 else
                                     return false;
                             }
                         },
                     },
                     {
                         headerName: "Net Rate",
                         field: 'net_cpa',
                         width: 90,
                         cellStyle: {'text-align': "right"},
                         cellRenderer: function(params) {
                             this.eGui = document.createElement('div');
                             $(this.eGui).css('text-align', 'right');
                             this.eGui.innerHTML = '';
                             if( typeof params.node.data !== 'undefined') {
                                 if (params.node.data.tiered_rate == 1)
                                     this.eGui.innerHTML = 'TR';
                                 else {
                                     if (isNaN(parseFloat(params.value)))
                                         this.eGui.innerHTML = '$0.00';
                                     else
                                         this.eGui.innerHTML = parseFloat(params.value).toLocaleString("en-US", {
                                             style: "currency",
                                             currency: "USD",
                                             //minimumFractionDigits: 2
                                         });
                                 }
                             }

                             return this.eGui;
                         },
                         cellClassRules :  {
                             'ag-cell-color-background': function(params) {
                                 if(typeof params.node.data !== 'undefined'  && typeof params.node.data.tiered_rate !== 'undefined' && params.node.data.tiered_rate === 1)
                                     return true;
                                 else
                                     return false;
                             }
                         },
                     }, {
                         headerName: "Len",
                         field: 'len',
                         width: 80,
                         cellStyle: {'text-align': "right"},
                         editable:true
                     },
                 ];
                 var camp_fd_ordered = data.FD;
                 for(var i in camp_fd_ordered){
                     var tiered_weeks = {
                         headerName: 'Week: '+ moment(camp_fd_ordered[i].start).format('MM/DD'),
                         headerTooltip: "Week: "+ moment(camp_fd_ordered[i].start).format('MM/DD'),
                         groupId: moment(camp_fd_ordered[i].start).format('MM/DD'),
                         children: [],
                         headerClass: 'group-header'
                     };
                     var row =  $.extend({}, extended_from_weeks.tired_rate);
                     row.field = 'w_'+ camp_fd_ordered[i].id + '_tired';
                     row.headerName = 'Rate';
                     tiered_weeks.children.push(row);

                     var row =  $.extend({}, extended_from_weeks.week);
                     row.field = 'week_'+ camp_fd_ordered[i].id ;
                     row.headerName = 'Ads';
                     tiered_weeks.children.push(row);
                     orderLinesRecordColumnDef.push(tiered_weeks);
                 }

                 $('#makegoodRecordGridDiv').html('');
                 gridRecordOrderLines.columnDefs = orderLinesRecordColumnDef;
                 gridRecordOrderLines.rowData = data.lines;
                 var gridRecordOrderLinesDiv = document.querySelector('#makegoodRecordGridDiv');
                 var g1 = new agGrid.Grid(gridRecordOrderLinesDiv, gridRecordOrderLines);

                 var html_1= '';
                 for(var ind in orderLinesRecordColumnDef){
                     if(orderLinesRecordColumnDef[ind].headerName !== 'Line Number' && orderLinesRecordColumnDef[ind].headerName !== 'MakeGood #') {
                         if (typeof orderLinesRecordColumnDef[ind].children === 'undefined') {
                             html_1 += '<li style="font-size: 12px; margin-bottom: -1px; margin-top: -1px;">' +
                                 '<a class="dropdown-item " data-hidden="' + orderLinesRecordColumnDef[ind].field + '" > ' + orderLinesRecordColumnDef[ind].headerName.replace('<br>', '') + '</a></li>';
                         } else {
                             for (var ind2 in orderLinesRecordColumnDef[ind].children) {
                                 html_1 += '<li style="font-size: 12px; margin-bottom: -1px; margin-top: -1px;">' +
                                     '<a class="dropdown-item " data-hidden="' + orderLinesRecordColumnDef[ind].children[ind2].field + '" > ' + orderLinesRecordColumnDef[ind].headerName + ' ' + orderLinesRecordColumnDef[ind].children[ind2].headerName + '</a></li>';
                             }
                         }
                     }
                 }
                 $("#hide_columns_makegood_record").html(html_1);

                 $('#order_ref_span_record').html(data.campaigns[0].reference_number);
                 $('#order_rev_n_span_record').html(data.campaigns[0].revision_number);
                 $('#station_order_div_record').html(data.campaigns[0].vendor_name);
                 if(data.campaigns[0].market_type == '')
                     market = 'Custom - ' + data.campaigns[0].market_name;
                 else if(data.campaigns[0].market_type == 'National')
                     market = 'National - ' + data.campaigns[0].market_name;
                 else
                     market =  data.campaigns[0].market_type.toUpperCase() + ' - ' + data.campaigns[0].market_name;
                 $('#market_order_div_record').html(market);

                 $('#makegood_record_total_span').html(data.makegood_totals.totals);
                 $('#makegood_record_total_approved_span').html(data.makegood_totals.approved);
                 $('#makegood_record_total_declined_span').html(data.makegood_totals.declined);

                 $('#recordMakeGoodModal').modal('show');
                 hide_loader();
             },
             error: function (xhr) {
                 hide_loader();
                 debug(xhr.responseText);
             }
         });
     }

    $(document).on('click', '.hide_columns_makegood_record a' , function (e){
        if ($(this).hasClass('hidden-column')) {
            gridRecordOrderLines.columnApi.setColumnVisible($(this).attr('data-hidden'), true);
            $(this).removeClass('hidden-column');
        } else {
            gridRecordOrderLines.columnApi.setColumnVisible($(this).attr('data-hidden'), false);
            $(this).addClass('hidden-column');
        }
        e.stopPropagation();
    });
    $('#reset_filters_makegood_record').on('click', function () {
        $.each(gridRecordOrderLines.api.getFilterModel(), function (index, value) {
            gridRecordOrderLines.api.destroyFilter(index);
        });
    });
    $('.export_makegood_record').on('click', function(){
        show_overlay_loader($('#recordMakeGoodModal .modal-content'));
        var type = $(this).attr('data');
        var html_header = '';
        var html_body = '';

        var columns_header = [];
        var columns_include = ['line_number'];
        var colums_group = [];
        var colums_group_header = [];
        $('.hide_columns_makegood_record a').each(function () {
            if ($(this).hasClass('hidden-column') == false)
                columns_include.push($(this).attr('data-hidden'))
        });
        var values_to_export = [];
        for(var ind in gridRecordOrderLines.columnDefs){
            if(typeof gridRecordOrderLines.columnDefs[ind].children === 'undefined') {
                if (columns_include.indexOf(gridRecordOrderLines.columnDefs[ind].field) !== -1) {
                    columns_header.push(gridRecordOrderLines.columnDefs[ind].headerName)
                    colums_group++;
                }
            }
            else{
                for(var ind2 in gridRecordOrderLines.columnDefs[ind].children){
                    if (columns_include.indexOf(gridRecordOrderLines.columnDefs[ind].children[ind2].field) !== -1) {
                        if(typeof  colums_group_header[gridRecordOrderLines.columnDefs[ind].headerName] === 'undefined')
                              colums_group_header[gridRecordOrderLines.columnDefs[ind].headerName] = 0;
                        columns_header.push(gridRecordOrderLines.columnDefs[ind].children[ind2].headerName);
                        colums_group_header[gridRecordOrderLines.columnDefs[ind].headerName]++;
                    }
                }
            }
        }
        gridRecordOrderLines.api.forEachNodeAfterFilterAndSort(function (node) {
            console.log('node', node);
            if(node.level == 2) {
                if (typeof values_to_export[node.data.makegood_reference_id] === 'undefined' &&  node.data.makegood_reference_id != "")
                    values_to_export[node.data.makegood_reference_id] = [];
                if (typeof values_to_export[node.data.makegood_reference_id][node.data.line_number] === 'undefined' &&  node.data.line_number != "")
                    values_to_export[node.data.makegood_reference_id][node.data.line_number] = [];

                if(node.data.makegood_reference_id != "" && node.data.line_number != ""){
                    var row = [];
                    row['tiered_rate'] = node.data.tiered_rate;
                    for (var ind in columns_include) {
                        row[columns_include[ind]] = typeof node.data[columns_include[ind]] !== 'undefined' && node.data[columns_include[ind]] !== null ? node.data[columns_include[ind]] : '';
                        if(columns_include[ind].indexOf('week_') !== -1){
                            var week_id = columns_include[ind].split('week_')[1];
                            if(typeof node.data['decrease_'+week_id] !== 'undefined')
                                row['decrease_'+week_id] = 1;
                            if(typeof node.data['increase_'+week_id] !== 'undefined')
                                row['increase_'+week_id] = 1;
                        }
                    }
                    values_to_export[node.data.makegood_reference_id][node.data.line_number].push(row);
                }
            }
        });
        var colspan = parseInt(columns_include.length );

        //Header
        html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr><td colspan="'+colspan+'"><b></b></td></tr></table>';
        html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center"><tr style="background-color: #F2F2F2"><td colspan="'+colspan+'"><b>MakeGoods Record </b></td></tr></table>';
        html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center;"><tr><td colspan="'+colspan+'"><b>Order: </b> '+  $('#order_ref_span_record').html() +' </td></tr></table>';
        html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center; "><tr><td colspan="'+colspan+'"><b>Revision #:</b> '+  $('#order_rev_n_span_record').html() +' </td></tr></table>';
        html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center; "><tr><td colspan="'+colspan+'"><b>Station: </b> '+ $('#station_order_div_record').html() +' </td></tr></table>';
        html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center; "><tr><td colspan="'+colspan+'"><b>Market: </b> '+ $('#market_order_div_record').html() +' </td></tr></table>';
        html_header += '<table style="margin-top: 2%; margin-bottom: 2%; text-align: center; "><tr><td colspan="'+colspan+'"></td></tr></table>';

        //Body
        html_body += '<table style="width: 100%; "><tr style="background: white;  color: black; border-right: white 1px solid"><td colspan="' + colspan + '">' ;
        html_body += '<b>Approved:</b> &nbsp;&nbsp;<span style="color: #F47A51;font-weight: bold">' + $('#makegood_record_total_approved_span').html()+'</span>' +
            ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Declined:</b> &nbsp;&nbsp; <span style="color: #F47A51;font-weight: bold">' + $('#makegood_record_total_declined_span').html() +' </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ' +
            '<b>Totals:</b> &nbsp;&nbsp; <span style="color: #F47A51;font-weight: bold">' + $('#makegood_record_total_span').html() + '</span>';
        html_body += '</td></tr>';
        html_body += '<tr style="background-color: #F2F2F2;  border-right: white 1px solid"><td colspan =" '+ colspan +' "></td></tr>';
        html_body += '</table>';
        //Group Line
        html_body += '<table style="width: 100%;border-bottom: #16181b 1px solid ; border-right: #16181b 1px solid;">' ;
        html_body += '<tr style="background-color: black; color: white !important; text-align: center;">';
        html_body += '<td colspan="'+ colums_group + '"></td>';
        for(var ind in colums_group_header)
            html_body += '<td style="background-color: #373737" colspan="'+ colums_group_header[ind] + '">&nbsp;&nbsp;&nbsp;&nbsp; ' +  ind + '&nbsp;&nbsp;&nbsp;&nbsp; </td>';
        html_body += '</tr>';

        //Header Line
        //Header Line
        html_body += '<tr style="background-color: black; color: white !important; text-align: center;">';
        for (var ind in columns_header) {
            if (columns_include[ind] == 'line_number')
                html_body += '<td style="text-align: left"> MakeGoods &nbsp;&nbsp;&nbsp;&nbsp;</td>';
            else if( columns_include[ind] == 'status')
                  html_body += '<td style="text-align: left"> ' + columns_header[ind] + '&nbsp;&nbsp;&nbsp;&nbsp;</td>';
            else if(columns_include[ind] == 'name' )
                html_body += '<td style="color: black">&nbsp;&nbsp;&nbsp;&nbsp; Name Of the Line &nbsp;&nbsp;&nbsp;&nbsp</td>';
            else
                html_body += '<td>&nbsp;&nbsp;&nbsp;&nbsp; ' + columns_header[ind] + '&nbsp;&nbsp;&nbsp;&nbsp;</td>';
        }
        html_body += '</tr>';

        //Rows Line
        for(var indxx in values_to_export) {
            html_body += '<tr style=" color: black !important; text-align: center;">';
            html_body += '<td style="text-align: left; background-color: #C8C8C8;" colspan="' +colspan+ '"><b> ' + indxx + '<b></td>';
            html_body += '</tr>';
            for(var ind in values_to_export[indxx]) {
                html_body += '<tr style=" color: black !important; text-align: center;">';
                html_body += '<td style="text-align: left; background-color: #F2F2F2;" colspan="' +colspan+ '">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ' + ind + '</td>';
                html_body += '</tr>';
                for (var index in values_to_export[indxx][ind]) {
                    html_body += '<tr style=" color: black !important; text-align: center;">';
                    for (var ind2 in columns_include) {
                        if(columns_include[ind2] == 'line_number')
                            html_body += '<td> </td>';
                        else if( columns_include[ind2] == 'status')
                            html_body += '<td style="text-align: left"> ' + values_to_export[indxx][ind][index][columns_include[ind2]] + ' </td>';
                        else if(columns_include[ind2] == 'name') {
                            if(values_to_export[indxx][ind][index][columns_include[ind2]] == "Offered by the seller")
                                html_body += '<td style="text-align: left; background-color: #e6e6fa"> ' + values_to_export[indxx][ind][index][columns_include[ind2]] + ' </td>';
                            else
                                html_body += '<td style="text-align: left;"> ' + values_to_export[indxx][ind][index][columns_include[ind2]] + ' </td>';
                        }
                        else {
                            var value = '';
                            if (columns_include[ind2].indexOf('rate') !== -1 || columns_include[ind2].indexOf('_cpa') !== -1 || columns_include[ind2].indexOf('_tired') !== -1) {
                                var color = '';
                                if (columns_include[ind2].indexOf('_cpa') !== -1 && values_to_export[indxx][ind][index].tiered_rate === 1) {
                                    value = "TR";
                                    color = '#CEE3F6';
                                } else if (values_to_export[indxx][ind][index][columns_include[ind2]] != '' && values_to_export[indxx][ind][index][columns_include[ind2]] !== null && !isNaN(parseFloat(values_to_export[indxx][ind][index][columns_include[ind2]]))) {
                                    value = parseFloat(values_to_export[indxx][ind][index][columns_include[ind2]]).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                        minimumFractionDigits: 2
                                    });
                                } else
                                    value = '';
                                html_body += '<td style="background-color: ' + color + '"> ' + value + '</td>';
                            } else if (columns_include[ind2].indexOf('week_') !== -1) {
                                var color = '';
                                var week_id = columns_include[ind2].split('week_')[1];
                                if (typeof values_to_export[indxx][ind][index]['decrease_' + week_id] !== 'undefined')
                                    color = '#F6CECE';
                                if (typeof values_to_export[indxx][ind][index]['increase_' + week_id] !== 'undefined')
                                    color = '#d0f0c0';
                                html_body += '<td style="background-color: ' + color + '"> ' + values_to_export[indxx][ind][index][columns_include[ind2]] + '</td>';
                            } else
                                html_body += '<td> ' + values_to_export[indxx][ind][index][columns_include[ind2]] + '</td>';
                        }
                    }
                    html_body += '</tr>';
                }
            }
        }

        html_body += '<tr style="background-color: #F2F2F2"><td colspan =" '+ colspan +' "></td></tr>';
        html_body += '</table>';
        var html = html_header + html_body;

        if(type=='xls'){
            var a = document.createElement('a');
            var data_type = 'data:application/vnd.ms-excel';
            a.href = data_type + ', ' + encodeURIComponent(html);
            a.download = 'MakeGoods Record ' + moment().format('MM-DD-YYYY') + '.xls';
            //triggering the function
            a.click();
        }
        else{
            var url='data:application/csv,charset=utf-8,' + encodeURIComponent(html);
            location.href=url;
            return false;
        }


        hide_overlay_loader($('#recordMakeGoodModal .modal-content'));
    });


    initializeMakegoodPendingTable(moment().startOf('year').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD"));

    function TiredRateMakeGoodFormatRenderer() {
    }

    TiredRateMakeGoodFormatRenderer.prototype.init = function (params) {
        this.eGui = document.createElement('div');

        $(this.eGui).css('text-align', 'right');

        if (params.node.rowPinned !== 'bottom') {
            if (typeof params.value !== 'undefined' && params.value != null) {
                param_val = parseFloat(params.value).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    //minimumFractionDigits: 2
                });
                if (isNaN(parseFloat(params.value))) {
                    this.eGui.innerHTML = null;
                } else {
                    this.eGui.innerHTML = param_val;
                }
            } else {
                this.eGui.innerHTML = null;
            }
        } else {
            this.eGui.innerHTML = '';
        }
    };

    TiredRateMakeGoodFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };

    //Close Display MakeGoodModal
     $('.close_makeGoodModal').on('click', function () {
         if(reload_datatable === true) {
             if(parseInt($('#makeGoodCount_one').html()) === 1){
                 $('#makeGoodCount_one').hide();
                 $('#makeGoodCount_two').hide();
                 $('#makeGoodCount_three').hide();
             } else {
                 $('#makeGoodCount_one').html(parseInt($('#makeGoodCount_one').html()) - 1);
                 $('#makeGoodCount_two').html(parseInt($('#makeGoodCount_two').html()) - 1);
                 $('#makeGoodCount_three').html(parseInt($('#makeGoodCount_three').html()) - 1);
             }
             show_view_data_table($('.makegood_filters').attr('data-value'));
         }

         $('#displayMakeGoodModal').modal('hide');

     });

}

var app_completed_makegood_table = $('#app-completed-makegood-table');

if (app_completed_makegood_table.length) {
    var global_view_type = 1;
    var data_table_order= [ 7, "desc" ];
    function initializeMakegoodCompletedTable(range = "") {
        app_completed_makegood_table.DataTable({
            "processing": true,
            "serverSide": true,
            ajax: {
               // url: '/makegoods/index/completed?view_type='+ global_view_type,
                url: '/communications_hub/index/completed?view_type='+ global_view_type,
                dataSrc: 'data',
            },
            order: [ 7, "desc" ],
            columns: [
                {data: 'rev_id'},//0
                {data: 'reference_number'},//1
                {data: 'revision_number'},//2
                {data: 'vendor_name'},//3
                {data: 'quantity'},//4
                {data: 'received_at'},//5
                {data: 'campaign_name'},//6
                {data: 'communication_type'},//7
                {data: 'completed_by'},//8
                {data: 'moved_complete_date'},//9
                {data: 'rev_id'},//10
            ],
            destroy: true,
            pageLength: user_entries,
            "columnDefs": [
                {
                    "targets": 6,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        console.log('rowData......', rowData);
                        console.log('row......', row);
                        $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                    }
                },
                {
                    "targets": 7,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        if(parseInt(cellData) === 1)
                            html += '<i style="color: #f15925" class="fa fa-handshake-o" title="MakeGood"></i>';
                        else if(parseInt(cellData) === 2)
                            html += '<i style="color: #f15925" class="fa fa-shopping-cart fa-fw" title="Order"></i>';
                        else if(parseInt(cellData) === 3)
                            html += '<i style="color: #f15925" class="fa fa-book" title="Proposal"></i>';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 3,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        console.log('rowData......', rowData);
                        console.log('row......', row);
                        $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                    }
                },
                {
                    "targets": 4,
                    "orderable": false,
                },
                {
                    "targets": 0,
                    "orderable": false,
                    "className": "text-left",
                    "visible": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = ' <div class="checkbox checkbox-danger makegoods_completed_check"> <input class="checkbox" class="form-control" type="checkbox"  id="' + rowData.rev_id + '" name="selected_makegoods[]" value="' + rowData.rev_id + '" ><label for="' + rowData.id + '"> </label></div>';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 10,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        html = '<div class="row text-center " style="">' ;
                        html +=    '<div class="btn-group " role="group" >';
                        html += ' <button class="btn btn-info btn-outline btn-sm display_makegood_completed_record " type="button"  data-id="' + rowData.rev_id + '"><i class="fa fa-cloud"></i> Record </button> ';
                        // html += ' <button class="btn btn-info btn-outline btn-sm cancel_order " type="button"  data-id="' + rowData.rev_id + '"><i class="fa fa-cloud"></i> Cancel </button> ';
                        html += '</div>' ;
                        html +=  '</div>';

                        $(td).html(html);
                    }
                },
            ]
        });
    }
    $('#app-completed-makegood-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries= len;
    });
    $('#app-completed-makegood-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order=[len[0].col, ""+len[0].dir+""];
    } );

    //Search Function
    $('#advertiser-search-order-completed').select2({
        minimumResultsForSearch: 5,
        placeholder: 'Select one....',
    });
    $('#vendor-search-order-completed').select2({
        minimumResultsForSearch: 5,
        placeholder: 'Select one....',
    });
    $('#campaign-search-order-completed').select2({
        minimumResultsForSearch: 5,
        placeholder: 'Select one....',
    });
    $('#market-search-order-index-completed').select2({
        minimumResultsForSearch: 5,
        placeholder: 'Select one....',
    });
    $('#advertiser-search-order-completed').on('change', function(){
        if($('#advertiser-search-order-completed option:selected').val() == '' || $('#advertiser-search-order-completed option:selected').val() == 'undefined') {
            $('#campaign-search-order-completed').html('');
            $('#vendor-search-order-completed').html('');
            $('#market-search-order-index-completed').html('');
        }
        else{
            show_loader();
            $.ajax({
                type: 'GET',
                url: '/invoices/search_campaign/' + $('#advertiser-search-order-completed option:selected').val(),
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var html='';
                    for(var i in data.campaigns)
                        html+='<option value="'+data.campaigns[i].id+'">'+data.campaigns[i].name+'</option>';
                    $('#campaign-search-order-completed').html(html);

                    $('#vendor-search-order-completed').html('');
                    $('#market-search-order-index-completed').html('');
                    hide_loader();

                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });
    $('#campaign-search-order-completed').on('change', function(){
        if($('#campaign-search-order-completed').val().length == 0 ) {
            $('#vendor-search-order-completed').html('');
            $('#market-search-order-index-completed').html('');
        }
        else{
            show_loader();
            var params={
                campaigns: $('#campaign-search-order-completed').val(),
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/orders/all/search_campaign_vendors',
                dataType: "json",
                contentType: "application/json",
                success: function (data) {
                    var html='';
                    for(var i in data.vendors)
                        html+='<option value="'+data.vendors[i].id+'">'+data.vendors[i].name+'</option>';
                    $('#vendor-search-order-completed').html(html);

                    var html='';
                    for(var i in data.markets)
                        html+='<option value="'+data.markets[i].id+'"> '+data.markets[i].type.toUpperCase()+'- '+data.markets[i].name+'</option>';

                    $('#market-search-order-index-completed').html(html);
                    hide_loader();

                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });
    $('#reset-sta-search-order-index-completed').on('click', function () {
        show_loader();
        var html= $('#advertiser-search-order-completed').html();
        $('#advertiser-search-order-completed').html('');
        var advertisers_xd = [];
        advertisers_xd.push({'id': '', 'text': '', 'title': ''});
        $.each(advertisers, function (index, value) {
            advertisers_xd.push({'id': value.id, 'text': value.name, 'title': value.name});
        });

        advertisers_xd.sort(function (a, b) {if (a.text > b.text) {return 1;}if (a.text < b.text) {return -1;}return 0;});
        $('#advertiser-search-order-completed').html('').select2({
            'data': advertisers_xd,
            placeholder: "Select one...",
        });
        $('#campaign-search-order-completed').html('');
        $('#vendor-search-order-completed').html('');
        $('#market-search-order-index-completed').html('');
        hide_loader();
    });
    $('#submit-search-order-all-index-completed').on('click', function () {
        SearchOrderCompleted();
    });
    function SearchOrderCompleted() {
        var market= JSON.stringify($('#market-search-order-index').val());
        var advertiser=  $('#advertiser-search-order-completed').val();
        var camp=  JSON.stringify($('#campaign-search-order-completed').val());
        var vend= JSON.stringify( $('#vendor-search-order-completed').val());

        if(( advertiser == '' || advertiser == null) && market.length ==0 && camp.length == 0 && vend.length == 0)
            global_notification('warning', 'Please select at least one search parameter...');
        else {
            show_loader();
            $('#panel_click_ven_search_completed').addClass('panel-collapsed');
            $('#panel_body_search_vendor_completed').css('display', 'none');

            var url = encodeURI('/makegoods/index/completed?view_type='+ global_view_type +'&advertiser='+advertiser+'&campaigns='+camp+'&markets='+market+'&vendors='+vend+'');

            $('#app-completed-makegood-table').DataTable().ajax.url(url).load();
            hide_loader();
        }
    }

    //Select/Descelect all
    $('#select_all_completed_makegoods').on('click', function (e) {
        $('#app-completed-makegood-table input:checkbox').each(function () {
            $(this).prop('checked', true);
        });
    });
    $('#deselect_all_completed_makegoods').on('click', function (e) {
        $('#app-completed-makegood-table input:checkbox').prop('checked', false);
    });

    $('#move_to_active').on('click', function(){
        var url= $(this).attr('data-url');
        var selectedItems = [];
        $('.makegoods_completed_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        if (selectedItems.length == 0) {
            swal({
                    title: "Warning!",
                    text: "Please select at least one Order.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    //cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                    }
                });
        }
        else{
            show_loader();
            var params = {
                orders: selectedItems,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    hide_loader();
                    global_notification('success', 'Order moved to Active.');
                    location.reload();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        }
    });


    //Record Order Lines Grid
    var extended_from_weeks = {
        'week':    {
            headerName: '',
            field: 'week_',
            width: 100,
            cellStyle: {'text-align': "left"},
            editable: true,
            // cellRenderer: IntegerFormatRenderer,
            tooltip: function (params) {
                if (typeof params.data !== 'undefined') {
                    var index = params.colDef.field;
                    index = index.toString().split('_')[1];
                    if (typeof params.data['increase_' + index] !== 'undefined')
                        return 'Spots Increase By: ' + params.data['increase_' + index];
                    if (typeof params.data['decrease_' + index] !== 'undefined')
                        return 'Spots Decrease By: ' + params.data['decrease_' + index];
                }
            },
            cellClassRules :  {
                'ag-cell-color-increase-makegood': function(params) {
                    var index = params.colDef.field;
                    index = index.toString().split('_')[1];
                    if (typeof params.data !== 'undefined' && typeof params.data['increase_' + index] !== 'undefined')
                        return true;
                },
                'ag-cell-color-decrease-makegood': function(params) {
                    var index = params.colDef.field;
                    index = index.toString().split('_')[1];
                    if (typeof params.data !== 'undefined' && typeof params.data['decrease_' + index] !== 'undefined')
                        return true;
                }
            },
        },
        'tired_rate':    {
            headerName: '',
            field: 'w_',
            width: 100,
            cellStyle: {'text-align': "left"},
            editable: true,
            cellRenderer: TiredRateMakeGoodFormatRenderer,
            // cellClassRules :  {
            //     'ag-cell-color-background': function(params) {
            //         var index = params.colDef.field;
            //         index = index.toString().split('_')[1];
            //         if (params.node.rowPinned != 'top' ) {
            //             if(typeof params.data['w_'+ index +'_tired'] !== 'undefined' &&  params.data['w_'+ index +'_tired'] !== null &&  params.data['w_'+ index +'_tired'] !== '' ) {
            //                 console.log('rated tired value ', params.data['w_'+ index +'_tired']);
            //                 return true;
            //             }
            //             else
            //                 return false;
            //         }
            //         return false;
            //     }
            // },
        },
    }


    // Record Function
    $('#app-completed-makegood-table').on('click', '.display_makegood_completed_record', function () {
        show_loader();
        displayRecord( $(this).attr('data-id'));
    });

    $('#app-completed-makegood-table').on('click', '.cancel_order', function () {
        init_progress_loader(2, 'This operation could take few seconds. Please wait ...');
        $.ajax({
            type: 'GET',
            url: '/makegoods/test/import/makegood/' + $(this).attr('data-id'),
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log(data);
                // for (var i in data) {
                //     console.log(data[i]);
                    saveFile( "testing cancel order.xml", "data:attachment/xml", data);
                //}
                close_progress_loader();
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
                close_progress_loader();
            }
        });
    });
    function saveFile (name, type, data) {
        if (data != null && navigator.msSaveBlob)
            return navigator.msSaveBlob(new Blob([data], { type: type }), name);
        var a = $("<a style='display: none;'/>");
        var url = window.URL.createObjectURL(new Blob([data], {type: type}));
        a.attr("href", url);
        a.attr("download", name);
        $("body").append(a);
        a[0].click();
        window.URL.revokeObjectURL(url);
        a.remove();
        console.log('---------------------------------------------------------------------------------');
        console.log(data);
    }
    initializeMakegoodCompletedTable(moment().startOf('year').format("YYYY-MM-DD") + "_" + moment().format("YYYY-MM-DD"));

    function TiredRateMakeGoodFormatRenderer() {
    }

    TiredRateMakeGoodFormatRenderer.prototype.init = function (params) {
        this.eGui = document.createElement('div');

        $(this.eGui).css('text-align', 'right');

        if (params.node.rowPinned !== 'bottom') {
            if (typeof params.value !== 'undefined' && params.value != null) {
                param_val = parseFloat(params.value).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    //minimumFractionDigits: 2
                });
                if (isNaN(parseFloat(params.value))) {
                    this.eGui.innerHTML = null;
                } else {
                    this.eGui.innerHTML = param_val;
                }
            } else {
                this.eGui.innerHTML = null;
            }
        } else {
            this.eGui.innerHTML = '';
        }
    };

    TiredRateMakeGoodFormatRenderer.prototype.getGui = function () {
        return this.eGui;
    };

}
